/* Trigger a click on the #accessiblyAppDialogButton */
jQuery(document).on('click', '.navmenu-id-accessibility a', function() {
    event.preventDefault();
    jQuery('#accessiblyAppDialogButton').click();
});